document.addEventListener("DOMContentLoaded", async () => {
  const container = document.getElementById("recently-viewed-products-list");
  if (!container) return;

  let viewed = JSON.parse(localStorage.getItem("recentlyViewedProducts")) || [];

  // 今見ている商品
  const currentHandle = window.location.pathname.split("/products/")[1].split("?")[0];

  // 保存
  viewed = viewed.filter(h => h !== currentHandle);
  viewed.unshift(currentHandle);
  viewed = viewed.slice(0, 10);

  localStorage.setItem("recentlyViewedProducts", JSON.stringify(viewed));

  // 現在の商品は表示しない
  const products = viewed.filter(h => h !== currentHandle);

  for (const handle of products) {
  try {
    const res = await fetch(`/products/${handle}.js`);
    const product = await res.json();

    const image = product.featured_image;

    container.innerHTML += `
<li class="group list-none flex-shrink-0 w-[65%] lg:w-auto">
        <a href="${product.url}" class="block">

          <div class="relative">
            <img
              src="${image}"
              alt="${product.title}"
              loading="lazy"
              class="w-full aspect-square object-contain"
            >
          </div>

          <div class="pt-4">
            <p class="text-sm leading-tight">
              ${product.title}
            </p>

            <p class="mt-2 font-medium">
              ¥${(product.price / 100).toLocaleString()}
            </p>
          </div>

        </a>
      </li>
    `;
  } catch (e) {
    console.log(e);
  }
}
});